import { defineComponent as _defineComponent } from 'vue'
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import PosterGraphql from '@/components/poster/PosterGraphql.vue';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import {
	SnowplowTitleContextGraphql,
	SnowplowClickoutContextGraphql,
	type SnowplowContext,
} from '@/helpers/tracking/providers/snowplow-contexts';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { calculateViewport } from '@/helpers/ui-helper';
import SingleRankingDisplay from '@/components/streaming-charts/SingleRankingDisplay.vue';
import WatchNowButton from '@/components/buttons/WatchNowButton.vue';
import { Viewport } from '@/enums/viewport';
import Top10TitleSwiper from './Top10TitleSwiper.vue';
import { getSelectedTab } from './helper';
import { computed, ref, watch } from 'vue';
import { useLanguageStore, useRoutingStore, useUserStore } from '@/helpers/composables/useStores';
import { useMounted, useWindowSize } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'Top10HorizontalTitleListGraphql',
  props: {
    titles: { default: () => [] },
    isBlocking: { type: Boolean },
    preventDefault: { type: Boolean },
    showQuickActions: { type: Boolean },
    hasMoreLikeThis: { type: Boolean },
    showSeenList: { type: Boolean },
    showMobileTitle: { type: Boolean },
    titleText: { default: '' },
    showPosition: { type: Boolean },
    additionalContexts: { default: () => [] }
  },
  emits: ["scrollbarClicked", "onTitleClick"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'scrollbarClicked', payload: { direction: 'left' | 'right'; position: number }): void;
	(e: 'onTitleClick', payload: { index: number; title: TitleDetail }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { titles: TitleDetail[], isBlocking?: boolean, preventDefault?: boolean, showQuickActions?: boolean, hasMoreLikeThis?: boolean, showSeenList?: boolean, showMobileTitle?: boolean, titleText: string, showPosition?: boolean, additionalContexts: SnowplowContext[] };





const { isLoggedIn } = useUserStore();
const languageStore = useLanguageStore();
const routingStore = useRoutingStore();

const isMounted = useMounted();
const isLoading = ref(false);

const { width } = useWindowSize();
const isMobileView = computed(() => (isMounted.value ? calculateViewport(width.value) === Viewport.SMARTPHONE : false));

const isFrench = computed(() => languageStore.language.value === 'fr');

const titlesContainerComp = computed(() => {
	if (isMobileView.value) {
		return {
			cmp: Top10TitleSwiper,
			props: {
				titleCount: props.titles.length,
			},
			methods: { slideChange },
		};
	}

	return {
		cmp: HiddenHorizontalScrollbar,
		props: {
			additionalContexts: props.additionalContexts,
		},
	};
});

watch(
	() => props.titles,
	() => {
		isLoading.value = true;

		setTimeout(() => {
			isLoading.value = false;
		}, 200);
	}
);

function slideChange(payload: { direction: 'left' | 'right'; position: number }) {
	emit('scrollbarClicked', payload);
}

function handleTitleClick(index: number, title: TitleDetail) {
	emit('onTitleClick', { index, title });
}

function getTitleName(title: TitleDetail) {
	if (title.__typename === 'Season') {
		return title?.show?.content?.title;
	}

	return title.content.title;
}

function handleWatchNowClick(titleNode: TitleDetail) {
	const selectedTab = getSelectedTab(routingStore.activeRoute.value?.name);

	const contexts: SnowplowContext[] = [new SnowplowTitleContextGraphql(titleNode.objectId, titleNode.objectType)];
	if (titleNode.watchNowOffer) {
		contexts.push(SnowplowClickoutContextGraphql.fromProviderOffer(titleNode.watchNowOffer));
	}

	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'watchnow_clicked',
			label: 'top-10-titles',
			property: selectedTab,
		},
		contexts
	);
}

return { __sfc: true,props, emit, isLoggedIn, languageStore, routingStore, isMounted, isLoading, width, isMobileView, isFrench, titlesContainerComp, slideChange, handleTitleClick, getTitleName, handleWatchNowClick, PosterGraphql, TitleDetailLink, SingleRankingDisplay, WatchNowButton }
}

})